import Medusa from '@medusajs/js-sdk';

export const sdk = new Medusa({
  baseUrl: process.env.NEXT_PUBLIC_MEDUSA_URL!,
  debug: process.env.NODE_ENV === 'development',
  auth: {
    type: 'jwt',
  },
  publishableKey: process.env.NEXT_PUBLIC_MEDUSA_PUBLISHABLE_KEY,
});
